module.exports = __webpack_public_path__ + "static/media/user-md-chat.dc6cb701.svg";